/**
 * Collector (veri kaynağı) canlılık durumu — gateway `source_status` event'inden.
 *
 * Amaç: "bağlı + collector canlı ama fiyat sabit" (hafta sonu/sakin piyasa) ile
 * "feed gerçekten kesik" (collector öldü / bağlantı koptu) durumlarını ayırmak.
 * Birincisi sahte "akış kesildi" alarmı vermemeli (screen-status 'calm' döner).
 *
 * Belirsizlik politikası: hiç source_status alınmadıysa (eski gateway / yeni bağlantı
 * anı) `alive=true` varsayılır → sahte alarm verme. Socket online olduğu sürece gateway
 * ayaktadır ve source_status gönderir; collector ölünce any_alive=false gelir → o zaman alarm.
 */
interface SourceStatusPayload {
    sources?: Record<string, boolean>;
    any_alive?: boolean;
    server_ts?: number;
}

let anyAlive = true; // belirsizken alarm verme
let lastUpdateMs = 0;

export function setSourceStatus(payload: SourceStatusPayload): void {
    anyAlive = payload.any_alive !== false; // yalnız açıkça false ise ölü say
    lastUpdateMs = Date.now();
}

/** En az bir collector canlı mı? (source_status gelmemişse iyimser: true) */
export function collectorsAlive(): boolean {
    return anyAlive;
}

export function hasSourceStatus(): boolean {
    return lastUpdateMs > 0;
}
